import React, { useContext, useEffect, useRef, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import toastContext from "../../../../context/toast/ToastContext";
import userContext from "../../../../context/users/UserContext";
import { TOAST_TYPE, USERTYPES } from "../../../../constants/Constants";
import AiDraftPanel from "./AiDraftPanel";
import useAiDraft from "./useAiDraft";

/**
 * Everything a viewer top bar needs for the AI Draft button (basic viewer TopBar, Advance Viewer
 * AdvTopBar): the generations of the study, the panel (model picker, one tab per generation) and
 * the element to mount. Radiologists only; the backend decides whether the feature is enabled for
 * the study.
 *
 * @param studyId            DB id of the open study
 * @param keyImagesModalOpen whether the top bar's "Manage key images" modal is open; closing it
 *                           re-checks the key images the draft can be built from
 */
const useAiDraftToolbar = ({ studyId, keyImagesModalOpen = false }) => {
  const { roles } = useContext(userContext);
  const { keyObjectImages } = useContext(studyviewerContext);
  const { showToastv2 } = useContext(toastContext);

  const aiDraft = useAiDraft(studyId, roles?.[0] == USERTYPES.RADIOLOGIST);
  const [showPanel, setShowPanel] = useState(false);
  const keyImagesSeenRef = useRef(false);

  useEffect(() => {
    if (aiDraft.announcement) showToastv2(TOAST_TYPE.INFO, aiDraft.announcement);
  }, [aiDraft.announcement]);

  // key images marked or (un)selected in this session change what the draft can be built from
  useEffect(() => {
    if (!keyImagesSeenRef.current) {
      keyImagesSeenRef.current = true;
      return;
    }
    if (!keyImagesModalOpen) aiDraft.refresh();
  }, [keyObjectImages?.length, keyImagesModalOpen]);

  // the panel holds the model picker, so "generate" and "open" both open it
  const openAiDraftPanel = () => setShowPanel(true);
  const generateAiDraft = openAiDraftPanel;

  const aiDraftPanel = showPanel ? <AiDraftPanel aiDraft={aiDraft} onClose={() => setShowPanel(false)} /> : null;

  return { aiDraft, generateAiDraft, openAiDraftPanel, aiDraftPanel };
};

export default useAiDraftToolbar;
